var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "提前解冻停车月卡",
        visible: _vm.visible,
        width: "640px",
        "append-to-body": "",
        "close-on-click-modal": false,
        "before-close": _vm.handleCancel,
        "custom-class": "unfreeze-parking-card-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "unfreeze-alert" }, [
        _vm._v(
          "\n    提前解冻后，月卡将立即恢复生效。原冻结结束时间不再执行，系统将以本次填写的“提前解冻时间”作为实际冻结结束时间。\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          staticClass: "unfreeze-form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品名称" } },
            [
              _c("el-input", {
                attrs: { value: _vm.display.productName, disabled: "" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "停车场名称" } },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.display.parkName,
                    placement: "top",
                    disabled: !_vm.display.parkName,
                    "popper-class": "parking-name-tooltip",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { value: _vm.display.parkName, disabled: "" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "车牌号" } },
            [
              _c("el-input", {
                attrs: { value: _vm.display.plateNo, disabled: "" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "当前月卡状态" } },
            [
              _c("el-tag", { attrs: { type: "warning", size: "small" } }, [
                _vm._v(_vm._s(_vm.display.statusText)),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "原冻结时间" } },
            [
              _c("el-input", {
                attrs: { value: _vm.display.freezeTimeText, disabled: "" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "提前解冻时间", prop: "unfreezeTime" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  type: "datetime",
                  format: "yyyy/MM/dd HH:mm",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  placeholder: "请选择提前解冻时间",
                  "picker-options": _vm.pickerOptions,
                },
                model: {
                  value: _vm.form.unfreezeTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "unfreezeTime", $$v)
                  },
                  expression: "form.unfreezeTime",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "field-tip" }, [
                _vm._v(
                  "可选择实际提前恢复生效的时间，不能早于冻结开始时间，也不能晚于原冻结结束时间。解冻时间不足1天，按1天计算。"
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "解冻原因" } },
            [
              _c("el-input", {
                staticClass: "reason-textarea",
                attrs: {
                  type: "textarea",
                  rows: 3,
                  maxlength: "100",
                  "show-word-limit": "",
                  placeholder: "请输入提前解冻原因",
                },
                model: {
                  value: _vm.form.reason,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "reason", $$v)
                  },
                  expression: "form.reason",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "上传附件", required: "" } }, [
            _c(
              "div",
              {
                staticClass: "attach-box",
                on: { click: _vm.chooseAttachment },
              },
              [
                _vm.form.attachment
                  ? [
                      _vm.form.attachment.extName !== "pdf"
                        ? _c("img", {
                            staticClass: "attach-preview",
                            attrs: { src: _vm.form.attachment.url, alt: "" },
                          })
                        : _c("i", {
                            staticClass: "el-icon-document attach-pdf",
                          }),
                      _vm._v(" "),
                      _c("div", { staticClass: "attach-name" }, [
                        _vm._v(_vm._s(_vm.form.attachment.fileName)),
                      ]),
                    ]
                  : [
                      _c("div", { staticClass: "attach-plus" }, [_vm._v("+")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "attach-link" }, [
                        _vm._v("从素材库选择附件"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "attach-hint" }, [
                        _vm._v("支持 JPG、PNG、PDF，单个文件不超过1MB"),
                      ]),
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "field-tip" }, [
              _vm._v("附件为必填项，用于留存提前解冻申请/审批凭证。"),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitting },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确认提前解冻")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }